const rootUrl = process.env.REACT_APP_API_URL || '';
const getHeaders = () => {
    const headers = new Headers();
    headers.append('x-api-key', process.env.REACT_APP_API_Key || '');
    return headers;
};

export const post = async (path: string = '', data: any = {}) => {
    return await fetch(
        `${rootUrl}${path}`,
        {
            method: 'POST',
            mode: 'cors',
            headers: getHeaders(),
            body: JSON.stringify(data),
        },
    );
};

export async function get<T>(path: string = '', gtfs: boolean = true, prefix?: string): Promise<T> {
    let newPath = '';
    (gtfs) ? newPath = '/gtfs' + path : newPath = path;
    (!!prefix) ? newPath = `${prefix}` + path : newPath = newPath;

    try {
        const response = await fetch(
            `${rootUrl}${newPath}`,
            {
                method: 'GET',
                mode: 'cors',
                headers: getHeaders(),
            },
        );
        return await response.json();
    } catch (e: any) {
        throw new Error(e.message);
    }
};

export async function locationCall(lat: any, lot: any): Promise<any> {
    const path = `/search/reverse?latitude=${lat}&longitude=${lot}`;
    return await fetch(
        `${rootUrl}${path}`,
        {
            method: 'GET',
            mode: 'cors',
            headers: getHeaders(),
        },
    )
        .then((response) => {
            return response.json();
        }).catch((err) => {
            return new Error(`ERROR`);
        });
};

export async function searchCall(query: string, lang: string): Promise<any> {
    const path = `/search/autocomplete?text=${query}+${lang}`;
    return await fetch(
        `${rootUrl}${path}`,
        {
            method: 'GET',
            mode: 'cors',
            headers: getHeaders(),
        },
    )
        .then((response) => {
            return response.json();
        }).catch((err) => {
            return new Error(`ERROR`);
        });
};

export async function placeIdCall(placeId: string): Promise<any> {
    const path = `/search/place/${placeId}`;
    return await fetch(
        `${rootUrl}${path}`,
        {
            method: 'GET',
            mode: 'cors',
            headers: getHeaders(),
        },
    )
        .then((response) => {
            return response.json();
        }).catch((err) => {
            return new Error(`ERROR`);
        });
};

export async function getCompartits<T>(url: string = ''): Promise<T> {
    return await fetch(
        `${url}`,
        {
            method: 'GET',
            mode: 'cors',
            headers: getHeaders(),
        },
    )
        .then((response) => {
            return response.json();
        }).catch((err) => {
            return new Error(`ERROR`);
        });
};
